import { apiClient } from './client';
import type { ApiResponse } from './types';
import type {
  Payment,
  CreatePaymentRequest,
  CreatePaymentResponse,
  PaymentFilters,
} from './paymentTypes';

export const paymentService = {
  // Create a new payment
  async createPayment(
    data: CreatePaymentRequest
  ): Promise<ApiResponse<CreatePaymentResponse>> {
    return apiClient.post<ApiResponse<CreatePaymentResponse>>(
      '/pis/create-payment',
      data
    );
  },

  // Get all payments with optional filters
  async getPayments(filters?: PaymentFilters): Promise<ApiResponse<Payment[]>> {
    const params = new URLSearchParams();

    if (filters?.status && filters.status !== 'ALL') {
      params.append('status', filters.status);
    }

    if (filters?.currency && filters.currency !== 'ALL') {
      params.append('currency', filters.currency);
    }

    const queryString = params.toString();
    const url = `/pis/payments${queryString ? `?${queryString}` : ''}`;

    return apiClient.get<ApiResponse<Payment[]>>(url);
  },

  // Get a single payment by ID
  async getPaymentById(id: string): Promise<ApiResponse<Payment>> {
    return apiClient.get<ApiResponse<Payment>>(`/pis/payments/${id}`);
  },

  // Get payment status by payment request ID (for callback)
  async getPaymentStatus(
    paymentRequestId: string
  ): Promise<ApiResponse<Payment>> {
    return apiClient.get<ApiResponse<Payment>>(
      `/pis/payment-status/${paymentRequestId}`
    );
  },

  // Get payment status by PAY/Connect sessionId (BANKSapi's own bank-redirect callback, e.g. N26 SCA)
  async getPaymentStatusBySessionId(
    sessionId: string
  ): Promise<ApiResponse<Payment>> {
    return apiClient.get<ApiResponse<Payment>>(
      `/pis/payment-status/session/${sessionId}`
    );
  },
};
